import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { CartProvider } from './context/CartContext';
import { FavoritesProvider } from './context/FavoritesContext';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileNav from './components/MobileNav';
import { Toaster } from './components/ui/toaster';
import Home from './pages/Home';
import BuyABook from './pages/BuyABook';
import Services from './pages/Services';
import About from './pages/About';
import Reviews from './pages/Reviews';
import Magazines from './pages/Magazines';
import Echoes from './pages/Echoes';
import ReadOnline from './pages/ReadOnline';
import Checkout from './pages/Checkout';
import Admin from './pages/Admin';
import Reader from './pages/Reader';
import Favourites from './pages/Favourites';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <main className="pb-16 lg:pb-0">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/buy" element={<BuyABook />} />
                <Route path="/echoes" element={<Echoes />} />
                <Route path="/read-online" element={<ReadOnline />} />
                <Route path="/about" element={<About />} />
                <Route path="/magazines" element={<Magazines />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/services" element={<Services />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/read/:bookId" element={<Reader />} />
                <Route path="/favourites" element={<Favourites />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <MobileNav />
            <Toaster />
          </BrowserRouter>
        </FavoritesProvider>
      </CartProvider>
    </div>
  );
}

export default App;
